export const notification = {
  notification: 'Notiser',
  allNotifications: 'Alla notiser',
  general: 'Allmänt',
  settings: 'Inställningar',
  newChatRequest: {
    youHaveANewChatRequest: 'Du har en ny chattförfrågan!!!',
    youHaveTransferredChatRequest: 'Du har överfört chattförfrågan!!!',
    acceptRequest: 'Acceptera förfrågan',
    discardRequest: 'Kasta förfrågan'
  },
  notificationList: {
    name: 'Namn',
    message: 'Meddelande',
    noDataFound: {
      notification: 'Notis',
      noNotificationsFound: 'Inga notiser hittades!',
    }
  },
  notificationSetting: {
    userMessage: 'Användarmeddelande',
    receiveNotificationsWhenUserSendMessage: 'Ta emot notiser när någon användare skickar ett meddelande',
    liveChatRequest: 'Förfrågan om livechatt',
    receiveNotificationsWhenUserRequestLiveChat: 'Ta emot notiser när någon användare begär livechatt',
    newLead: 'Nytt lead',
    receiveNotificationsWhenNewLeadCreated: 'Ta emot notiser när nya leads skapas',
    assignedOnly: 'Endast tilldelade',
    allUsers: 'Alla användare',
    customizeWhichNotificationsYouWantToRecieve: 'Anpassa vilka notiser du vill ta emot',
    youCanCustomizeSettingForTheNotifications: 'Du kan anpassa inställningarna för notiserna',
    receiveNotifications: 'Ta emot notiser',
    desktopNotifications: 'Skrivbordsnotiser',
    mobilePushNotifications: 'Mobil push-notiser',
    discard: 'Kasta',
    update: 'Uppdatera',
    appTooltip: {
      TOOLTIP_NEW_MESSAGE_DESKTOP_NOTIFICATION: 'Skicka notiser om nytt meddelande på skrivbordet',
      TOOLTIP_NEW_MESSAGE_MOBILE_NOTIFICATION: 'Skicka notiser om nytt meddelande på mobilen',
      TOOLTIP_NEW_LEAD_DESKTOP_NOTIFICATION: 'Skicka notiser om nytt lead på skrivbordet',
      TOOLTIP_NEW_LEAD_MOBILE_NOTIFICATION: 'Skicka notiser om nytt lead på mobilen',
      TOOLTIP_LIVE_CHAT_DESKTOP_NOTIFICATION: 'Skicka notiser om livechatt på skrivbordet',
      TOOLTIP_LIVE_CHAT_MOBILE_NOTIFICATION: 'Skicka notiser om livechatt på mobilen',
      TOOLTIP_RECEIVED_NOTIFICATION: 'Välj vilka meddelanden du vill få notiser för'
    }
  }
};
